module.exports = __webpack_public_path__ + "static/media/eye.20316f35.svg";